import { HttpClient } from '../common/httpClient';
import { PageResponse } from '../common/pagingModel';
import { Cdr, CdrsWithPageData } from '../../types/cdrs';

export type WhatsappCdrsResponse = {
  readonly id: number;
  readonly sender: string;
  readonly receiver: string;
  readonly destinationName: string;
  readonly account: string;
  readonly rate: number;
  readonly lastStatus: string;
  readonly createDateTime: string;
  readonly lastStatusTime: string;
  readonly statusDetails?: string;
};

export class WhatsappCdrsApi {
  constructor(private readonly httpClient: HttpClient) {}

  private mapToWhatsappCdrs(response: WhatsappCdrsResponse): Partial<Cdr> {
    return {
      id: response.id,
      sender: response.sender,
      receiver: response.receiver,
      destinationName: response.destinationName,
      account: response.account,
      rate: response.rate,
      lastStatus: response.lastStatus,
      createDateTime: response.createDateTime,
      lastStatusTime: response.lastStatusTime,
      statusDetails: response.statusDetails,
    };
  }

  getAll(url: string): Promise<CdrsWithPageData> {
    return this.httpClient.get(`${url}`)
  }

  getExports(): Promise<Partial<Cdr>[]> {
    return this.httpClient.get<PageResponse<WhatsappCdrsResponse>>(``)
      .then(data => (
        data.content.map(it => this.mapToWhatsappCdrs(it))
      ));
  }

  async delete(id: string): Promise<void> {
    await this.httpClient.delete<Cdr>(``);
  }
}
